import { ApolloError } from '@apollo/client';

import { Status } from 'apps/shared/scripts/__generated__/graphql.generated';
import { useCardById } from 'apps/shared/scripts/graphql';

interface Options {
  id: string;
  onError?: (error: ApolloError) => void;
}

const useIsCardDelivered = ({ id, onError }: Options) => {
  const { card, isLoading } = useCardById({
    variables: { id, consumer: true },
    onError,
  });
  const isDelivered =
    card && (card.status === Status.Published || card.status === Status.Sent);
  return { isDelivered, isLoading };
};

export default useIsCardDelivered;
